import { getType } from 'mime';

import APIFile from '../../models/File';

export const getCoverImage = (files: APIFile[], coverImage?: string): APIFile | undefined => {
  if (files) {
    for (let file of files) {
      if ((getType(file.originalname) || 'text').indexOf('image') !== -1) {
        return file;
      }
    }
  }

  return undefined;
}

export const tableTranslations = {
  body: {
    noMatch: 'Sem dados para mostrar',
    toolTip: 'Ordem',
  },
  filter: {
    all: 'Tudo',
    reset: 'Limpar',
    title: 'Filtros',
  },
  pagination: {
    displayRows: 'de',
    next: 'Próx. página',
    previous: 'Página ant.',
    rowsPerPage: 'Linhas por página',
  },
  selectedRows: {
    delete: 'Apagar',
    deleteAria: 'Apagar linhas seleccionadas',
    text: 'linha(s) seleccionadas',
  },
  toolbar: {
    downloadCsv: 'Descarregar CSV',
    filterTable: 'Filtrar tabela',
    print: 'Imprimir',
    search: 'Pesquisa',
    viewColumns: 'Ver colunas',
  },
  viewColumns: {
    title: 'Mostrar colunas',
    titleAria: 'Mostrar/esconder colunas da tabela',
  },
};

export const checkIfImage = (filename: string) => {
  return /\.(jpg|jpeg|gif|png|gif)$/.test(filename.toLowerCase());
};

// Latin letters that have no canonical NFD decomposition, so they would
// otherwise be lost. We map them to their plain base letter instead.
const LATIN_FALLBACK: Record<string, string> = {
  'ø': 'o', 'ð': 'd', 'đ': 'd', 'ł': 'l', 'ħ': 'h', 'ı': 'i', 'ĸ': 'k',
  'ŧ': 't', 'ß': 'ss', 'æ': 'ae', 'œ': 'oe',
};

// Lowercase and REPLACE every accented letter with its plain base letter
// (á -> a, ç -> c, ã -> a, ø -> o) — accented characters are never dropped.
// Only separators/punctuation are removed, so the search ignores case,
// accentuation and special characters.
export const normalizeText = (value?: string | null): string =>
  (value || '')
    .toLowerCase()
    .normalize('NFD')                                    // á -> "a" + combining accent
    .replace(/[̀-ͯ]/g, '')                     // remove only the accent mark, keep "a"
    .replace(/[øðđłħıĸŧßæœ]/g, (c) => LATIN_FALLBACK[c])  // base letters NFD can't decompose
    .replace(/[^a-z0-9]/g, '');                          // strip separators/punctuation

// Fuzzy match: returns true when every character of `query` appears in
// `target` in order (subsequence match), after normalization. An empty
// query matches everything.
export const fuzzyMatch = (target?: string | null, query?: string | null): boolean => {
  const q = normalizeText(query);
  if (!q) {
    return true;
  }

  const t = normalizeText(target);
  let i = 0;
  for (let j = 0; j < t.length && i < q.length; j += 1) {
    if (t[j] === q[i]) {
      i += 1;
    }
  }

  return i === q.length;
};
